exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sctv-file[data-v-405beddd]{display:flex;flex-wrap:wrap;margin:-.25rem}.sctv-file>*[data-v-405beddd]{flex-grow:1;flex-shrink:0;flex-basis:auto;margin:.25rem;width:auto}", ""]);

// exports
